import { MIXPANEL_EVENTS } from 'pages/leads/constants';
import useLeadsMixPanel from 'pages/leads/hooks/use-leads-mixpanel';
import * as T from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSearchParam } from 'react-use';
import CardFeedback from 'utils/old-ui-commons/card-feedback';

import { PinOutline } from '@olist/design-system-icons';
import { Box, Text } from '@olist/united';

import { isMobileSource } from '../../constants';
import SelectedQualificationItems from '../selected-qualification-items/selected-qualification-items';

const UnqualifiedCardFeedback = ({
  isUnqualifiedSegments,
  qualificationProfile,
  unqualifiedItem,
}) => {
  const { t } = useTranslation();

  const sourceParam = useSearchParam('source');
  const shouldShowTinyLink = unqualifiedItem.key === 'has_nfe_xml' && isMobileSource(sourceParam);
  const showKnowMoreLink = !isUnqualifiedSegments && !!unqualifiedItem.link && !shouldShowTinyLink;

  const showCustomKnowMoreLabel = !!unqualifiedItem.labelLink;

  const mixpanelInstance = useLeadsMixPanel();

  const handleLinkClick = (eventType) => {
    switch (eventType) {
      case 'has_nfe_xml':
        mixpanelInstance?.track(MIXPANEL_EVENTS.CLICKED_TO_SEE_TINY);
        break;
      case 'has_bank_account_associated_cnpj':
        mixpanelInstance?.track(MIXPANEL_EVENTS.CLICKED_TO_SEE_CORA);
        break;
      case 'respect_correios_max_dimensions':
        mixpanelInstance?.track(MIXPANEL_EVENTS.CLICKED_TO_SEE_MORE_ABOUT_ALLOWED_MEASURES);
        break;
      default:
        break;
    }
  };

  return (
    <Box mb={3}>
      <CardFeedback
        description={
          <Box lineHeight="120%" fontSize={1}>
            <Text color="textLight" display="inline">
              {unqualifiedItem.description}
            </Text>{' '}
            {showKnowMoreLink && (
              <Text.Link
                href={unqualifiedItem.link}
                onClick={() => handleLinkClick(unqualifiedItem.key)}
                target="_blank"
                data-ref="know-more-link"
              >
                {showCustomKnowMoreLabel ? unqualifiedItem.labelLink : t`know more`}
              </Text.Link>
            )}
            {isUnqualifiedSegments && (
              <SelectedQualificationItems qualificationProfile={qualificationProfile} />
            )}
          </Box>
        }
        icon={
          <Box pr={2}>
            {unqualifiedItem.icon === 'pin-outline' ? (
              <PinOutline color="#0C29D0" width={24} height={24} />
            ) : (
              <div />
              // <OIcon name={unqualifiedItem.icon} size={24} color="#0C29D0" />
            )}
          </Box>
        }
        title={
          <Box mb={1}>
            <Text fontSize={2} fontWeight="semibold">
              {unqualifiedItem.title}
            </Text>
          </Box>
        }
        variation="text"
      />
    </Box>
  );
};

UnqualifiedCardFeedback.propTypes = {
  isUnqualifiedSegments: T.bool.isRequired,
  qualificationProfile: T.shape({}).isRequired,
  unqualifiedItem: T.shape({
    description: T.node.isRequired,
    icon: T.string.isRequired,
    key: T.string.isRequired,
    labelLink: T.string,
    link: T.string.isRequired,
    title: T.string.isRequired,
  }).isRequired,
};

export default UnqualifiedCardFeedback;
